

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import Router from 'vue-router';
import $http from './request/http'
import touch from 'vue-directive-touch';
import 'lib-flexible/flexible'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import validUtils from "./utils/formValidation"  
import Vant from 'vant';
import 'vant/lib/index.css';
import preventReClick from '@/utils/preventReClick'; 
import { Toast } from 'vant';
Vue.use(touch);
Vue.use(Toast);
Vue.use(Vant);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);



Vue.prototype.validUtils = validUtils; 
Vue.prototype.$http = $http;
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch((err) => err);
};
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
let token = localStorage.getItem('token');
document.title = to.meta.title;

next();





})
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js